import Vue from 'vue'
import App from './App'
import router from './router'
import LoadScript from 'vue-plugin-load-script';
import store from './store'

Vue.use(LoadScript);
/**
 * Firebase  설정
 */
// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/storage";

var firebaseConfig = {
  apiKey: "AIzaSyC31PWyIQctMUltFiUEk3tHYnKvtO4JteY",
  authDomain: "uko-projects.firebaseapp.com",
  databaseURL: "https://uko-projects.firebaseio.com",
  projectId: "uko-projects",
  storageBucket: "uko-projects.appspot.com",
  messagingSenderId: "81206162832",
  appId: "1:81206162832:web:926b9745a50d1466f86f15",
  measurementId: "G-XK8VTY9ZQE"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
Vue.config.productionTip = false

import Vuetify from "vuetify";
import 'vuetify/dist/vuetify.min.css'
const EventBus = new Vue();

Vue.use(Vuetify)



let vm = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  vuetify: new Vuetify(),
})
window.app = vm



// WEBPACK FOOTER //
// ./src/main.js